import React from 'react';

export const EmptyStateSVG = () => (
  <svg
    width="162"
    height="102"
    viewBox="0 0 162 102"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.25 83V83C15.3857 87.9133 19.3367 91.8643 24.25 92V92V92C19.3367 92.1357 15.3857 96.0867 15.25 101V101V101C15.1143 96.0867 11.1633 92.1357 6.25 92V92V92C11.1633 91.8643 15.1143 87.9133 15.25 83V83Z"
      fill="#1F1F1F"
    />
    <path
      d="M153 34.5V34.5C153.136 39.4133 157.087 43.3643 162 43.5V43.5V43.5C157.087 43.6357 153.136 47.5867 153 52.5V52.5V52.5C152.864 47.5867 148.913 43.6357 144 43.5V43.5V43.5C148.913 43.3643 152.864 39.4133 153 34.5V34.5Z"
      fill="#1F1F1F"
    />
    <path
      d="M19.1667 35.0762C23.7456 35.0762 21.4784 53.4481 23.7456 53.4481C26.2842 53.4481 27.4401 24.578 30.2868 24.578C32.9759 24.578 33.0367 67.2269 36.1739 67.2269C39.3111 67.2269 40.0326 9.48682 42.7151 9.48682C45.5076 9.48682 44.6559 81.662 48.6022 81.662C52.3209 81.662 52.1384 9.48682 55.1435 9.48682C58.1609 9.48682 57.6743 67.2269 61.0305 67.2269C64.9134 67.2269 63.751 24.578 66.9176 24.578C70.0843 24.578 70.446 53.4481 73.4589 53.4481C76.4718 53.4481 76.8368 35.0762 80.0001 35.0762C82.9201 35.0762 83.0418 53.4481 85.8872 53.4481C88.9426 53.4481 89.2468 24.578 92.4284 24.578C95.61 24.578 94.7218 67.2269 98.3155 67.2269C101.909 67.2269 101.353 9.48682 104.203 9.48682C107.253 9.48682 106.706 81.662 110.744 81.662C114.493 81.662 113.458 9.48682 116.631 9.48682C119.663 9.48682 118.712 67.2269 123.172 67.2269C127.633 67.2269 124.895 24.578 129.059 24.578C133.223 24.578 132.953 53.4481 134.946 53.4481C136.94 53.4481 135.678 35.0762 140.833 35.0762"
      stroke="#0F0F0F"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M79.5 76.5V76.5C79.6884 83.324 85.176 88.8116 92 89V89V89C85.176 89.1884 79.6884 94.676 79.5 101.5V101.5V101.5C79.3116 94.676 73.824 89.1884 67 89V89V89C73.824 88.8116 79.3116 83.324 79.5 76.5V76.5Z"
      fill="#1F1F1F"
    />
    <path
      d="M7.5 0.5V0.5C7.61305 4.59439 10.9056 7.88695 15 8V8V8C10.9056 8.11305 7.61305 11.4056 7.5 15.5V15.5V15.5C7.38695 11.4056 4.09439 8.11305 0 8V8V8C4.09439 7.88695 7.38695 4.59439 7.5 0.5V0.5Z"
      fill="#1F1F1F"
    />
  </svg>
);
